import React, { createContext, useContext } from 'react';
import { getCurrentAppConfig } from '../config.js';

// 1. Create the context
const ConfigContext = createContext(null);

// 2. Create a provider component
export const ConfigProvider = ({ children }) => {
  const config = getCurrentAppConfig();

  // If config is null or undefined, you might want to render a loading state or an error
  if (!config) {
    return <div>Error: Application configuration could not be loaded.</div>;
  }

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};

// 3. Create a custom hook for easy consumption
export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};
